"use strict";
/**
 * @module Services.SessionLock
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
/**
 * Serialiser for {@link SessionLockRequest}
 */
var SessionLockRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(SessionLockRequestSerialiserClass, _super);
    function SessionLockRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link SessionLockRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link SessionLockRequest} to be written
     */
    SessionLockRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.lockName);
        Codec.writeInt64(bos, value.requestId);
        BEES.write(bos, value.scope);
    };
    return SessionLockRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SessionLockRequestSerialiserClass = SessionLockRequestSerialiserClass;
/**
 * The {@link SessionLockRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.SessionLockRequestSerialiser = new SessionLockRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/session-lock/session-lock-request-serialiser.js
// module id = 1986
// module chunks = 1